module.exports = __webpack_public_path__ + "static/img/contract_coach_temp.1cbe86d7.png";